
import { Button, Card, Image, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GalleryItem } from '../types/GalleryItem';
import DatePicker from "react-datepicker";

const ProductItem = ({ item, handleGalleryItemChange, handleRemoveItem }: { item: GalleryItem, handleGalleryItemChange: Function, handleRemoveItem: Function }) => {

    return <Card key={item.url ? item.url : item?.image?.original} className="p-3">
        <div style={{ width: "100%", height: "144px", overflow: "hidden", position: "relative", cursor: "pointer" }}>
            <Button variant="outline-danger" onClick={() => handleRemoveItem(item)} style={{ position: "absolute", top: 0, right: 0, zIndex: 1 }}>
                <FontAwesomeIcon icon="trash-alt" />
            </Button>
            <Image src={item?.image?.thumbnail || ''} style={{ maxHeight: "140px", position: "absolute", top: "0", left: "0", bottom: "0", right: "0" }} className="m-auto" />
        </div>
        <Card.Body className="p-0">
            <Form.Group className="mt-3">
                <Form.Label>Label</Form.Label>
                <Form.Control readOnly={true} placeholder="Label" defaultValue={item?.product?.code} type="text" />
            </Form.Group>
            <Form.Group className="mt-3">
                <Form.Label>Description</Form.Label>
                <div dangerouslySetInnerHTML={{ __html: item?.product?.description || '' }}></div>

            </Form.Group>

            <Form.Label>Valid Dates</Form.Label>
            <div>
                <DatePicker readOnly={true} selected={item?.product?.startDate} placeholderText="Start Date"
                    onChange={() => null}
                    selectsStart
                    startDate={item?.product?.startDate}
                    endDate={item?.product?.endDate} />
                <DatePicker readOnly={true} className="mt-2" selected={item?.product?.endDate} placeholderText="End Date"
                    onChange={() => null }
                    selectsEnd
                    startDate={item?.product?.startDate}
                    endDate={item?.product?.endDate}
                    minDate={item?.product?.startDate} />
            </div>
        </Card.Body>
    </Card>;
}
export default ProductItem;
